import { useDispatch, useSelector } from 'react-redux';
import { Dispatch, useCallback, useEffect, useMemo, useRef } from 'react';
import { useSharedState } from 'app/infrastructure/redux/hooks';
import { AuthState } from 'app/types-shared';
import { textCollectionActionCreators } from './actions';
import { AppSetting } from 'dependencies/appsettings';
import { mapTextPropsFromState, TextMap } from 'app/infrastructure/redux';
import { createDescriptionSelector } from 'app/infrastructure/translate';

export function useTranslation<T extends TextMap>(statePath: string, translations: T)
: { readonly [P in keyof typeof translations]: string } {
  
  const dispatch: Dispatch<any> = useDispatch();
  const texts = useSelector(state => state[statePath]?.texts);
  const sharedState = useSharedState();
  const loadedLanguage = useRef(undefined);

  const authState = sharedState?.authState;
  const validAuthState = authState === AuthState.Authenticated || authState === AuthState.Anonymous;
  const language = sharedState?.language?.value;

  const appSettingsTexts = AppSetting.Translations[statePath];

  const descriptionSelector = useCallback(createDescriptionSelector(texts), [texts]);

  useEffect(() => {
    if (validAuthState && language && loadedLanguage.current !== language) {
      loadedLanguage.current = language;
      dispatch(textCollectionActionCreators.loadTextCollection([statePath], language));
    }
  }, [validAuthState, language, loadedLanguage.current]);

  return useMemo(() => ({
    ...appSettingsTexts,
    ...mapTextPropsFromState(descriptionSelector, translations)
  }), [appSettingsTexts, descriptionSelector, translations]);
}
